import React from "react";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { Layout } from "./components/layouts/layout";
import { PresalePage } from "./pages/presale";

export const Router = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<PresalePage />} />
        </Routes>
      </Layout>
      <ToastContainer />
    </BrowserRouter>
  );
};
